import { createContext } from "react";

export const SubmissionContext = createContext();

export const UserContext = createContext();